import { MdBarChart } from "react-icons/md";
import Widget from "components/widget/Widget";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDashbord } from "store/dashboardSlice";
import OrdersTable from "./components/OrdersTable";
import ContainersTable from "./components/ContainersTable";
import UsersTable from "./components/UsersTable";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { dashboard: dashPerms = {} } = useSelector(
    (state) => state.auth.permissions || {}
  );

  const { dashboardData, dashboardLoading, dashboardError } = useSelector(
    (state) => state.dashboard
  );

  useEffect(() => {
    dispatch(getDashbord());
  }, [dispatch]);

  const widgets = useMemo(() => {
    const d = dashboardData?.data;

    const arr = [
      dashPerms?.ordersDetails && {
        icon: <MdBarChart className="h-6 w-6" />,
        title: "Orders",
        subtitle: d ? `${d.orders?.total || 0}` : "0",
      },
      dashPerms?.containersDetails && {
        icon: <MdBarChart className="h-6 w-6" />,
        title: "Containers",
        subtitle: d ? `${d.containers?.total || 0}` : "0",
      },
      dashPerms?.usersDetails && {
        icon: <MdBarChart className="h-6 w-6" />,
        title: "Users",
        subtitle: d ? `${d.users?.total || 0}` : "0",
      },
      dashPerms?.assignDetails && {
        icon: <MdBarChart className="h-6 w-6" />,
        title: "UnAssigned",
        subtitle: d ? `${d.mapping?.UnAssigned || 0}` : "0",
      },
      dashPerms?.assignDetails && {
        icon: <MdBarChart className="h-6 w-6" />,
        title: "Cleared",
        subtitle: d ? `${d.mapping?.Cleared || 0}` : "0",
      },
    ];

    return arr.filter(Boolean);
  }, [dashboardData]);

  return (
    <div>
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        {widgets.map((w, i) => (
          <Widget
            key={i}
            icon={w.icon}
            title={w.title}
            subtitle={w.subtitle}
            loading={dashboardLoading}
            error={dashboardError}
          />
        ))}
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-3">
        {dashPerms?.ordersDetails && (
          <div>
            <OrdersTable />
          </div>
        )}
        {dashPerms?.containersDetails && (
          <div>
            <ContainersTable />
          </div>
        )}
        {dashPerms?.usersDetails && (
          <div>
            <UsersTable />
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
